import { render, staticRenderFns } from "./FirstStep.vue?vue&type=template&id=13ca4180&scoped=true&lang=html&"
import script from "./FirstStep.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FirstStep.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./FirstStep.vue?vue&type=style&index=0&id=13ca4180&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca4180",
  null
  
)

export default component.exports